import Apollo from '@/store/interface/Apollo'
import Axios from '@/store/interface/Axios'
import gql from 'graphql-tag'
import { storage } from '@/utils/storage'
import { emitter } from '@/utils/emitter'

const apollo = new Apollo(process.env.VUE_APP_USER_API_GRAPHQL, false)
// apollo.setToken('Br1gh7')
const graphqlClient = apollo.client
const restClient = new Axios(process.env.VUE_APP_USER_API_REST)
// restClient.setToken('Br1gh7')

emitter.on('TOKEN', token => {
  apollo.setToken('Bearer ' + token)
  restClient.setToken('Bearer ' + token)
})

class APIUser {
  getUser () {
    const args = arguments

    const request = new Promise((resolve, reject) => {
      graphqlClient.query({
        query: gql`
          query {
            me {
              id
              uid
              firstName
              lastName
              company
              role
              favorites
              avatar
              share
              avatarPic
              email
              firstLogin
            }
          }
        `
      })
      .then(res => {
        const result = res.data.me

        result.avatar = typeof result.avatar === 'string' ? JSON.parse(result.avatar) : result.avatar
        result.favorites = typeof result.favorites === 'string' ? JSON.parse(result.favorites) : result.favorites

        resolve(result)
        storage.setItem(`me`, result)
      })
      .catch(err => {
        console.error('Error catching me params ', err)
      })
    })
    const cache = storage.getItem(`me`)

    return {
      request,
      cache
    }
  }

  getUserImage () {
    const request = new Promise((resolve, reject) => {
      graphqlClient.query({
        query: gql`
          query {
            me {
              id
              profilePic
            }
          }
        `
      })
      .then(res => {
        const result = res.data.me
        resolve(result)
      })
      .catch(err => {
        console.error('Error catching me params ', err)
      })
    })

    return {
      request
    }
  }

  updateAvatar (data) {
    const request = new Promise((resolve, reject) => {
      graphqlClient.mutate({
        mutation: gql`
          mutation updateAvatar ($data: JSONString) {
            updateAvatar (avatarData: $data){
              me {
                avatar
              }
            }
          }
        `,
        variables: { data: data }
      })
      .then(res => {
        const result = res.data.me
        resolve(result)
      })
      .catch(err => {
        console.error('Error updating avatar params ', err)
      })
    })

    return {
      request
    }
  }

  updateUser (data) {
    const request = new Promise((resolve, reject) => {
      graphqlClient.mutate({
        mutation: gql`
          mutation updateUser ($firstName: String, $lastName: String, $company: String, $role: String) {
            updateUser (firstName: $firstName, lastName: $lastName, company: $company, role: $role){
              me {
                id
              }
            }
          }
        `,
        variables: data
      })
      .then(res => {
        const result = res.data.me
        resolve(result)
      })
      .catch(err => {
        console.error('Error updating avatar params ', err)
      })
    })

    return {
      request
    }
  }

  addFav (data) {
    const request = new Promise((resolve, reject) => {
      graphqlClient.mutate({
        mutation: gql`
          mutation addFavorite ($craftId: String, $favorite: String) {
            addFavorite (craftId: $craftId, favorite: $favorite) {
              me {
                id
              }
            }
          }
        `,
        variables: { craftId: data.id, favorite: data.url }
      })
      .then(res => {
        const result = res.data.me
        resolve(result)
      })
      .catch(err => {
        console.error('Error updating avatar params ', err)
      })
    })

    return {
      request
    }
  }

  removeFav (uid) {
    const request = new Promise((resolve, reject) => {
      graphqlClient.mutate({
        mutation: gql`
          mutation deleteFavorite ($uid: String) {
            deleteFavorite (uid: $uid) {
              me {
                id
              }
            }
          }
        `,
        variables: { uid }
      })
      .then(res => {
        const result = res.data.me
        resolve(result)
      })
      .catch(err => {
        console.error('Error updating avatar params ', err)
      })
    })

    return {
      request
    }
  }

  updateAvatarPicture (data) {
    const request = new Promise((resolve, reject) => {
      restClient.post('image/base64/', data)
      .then(res => {
        const result = res.data.me
        resolve(result)
      })
      .catch(err => {
        console.error('Error updating avatar params ', err)
      })
    })

    return {
      request
    }
  }

  updateProfilePicture (file) {
    if (!file) { return Promise.reject(new Error('No file provided')) }

    return new Promise((resolve, reject) => {
      restClient.post(
        'image/upload/',
        file.data,
        {
          headers: {
            'Content-type': 'multipart/form-data',
            'Content-Disposition': `attachment;filename="${file.name}"`,
            ...restClient.headers
          }
        }
      ).then(result => {
        resolve(result.data)
      }).catch(error => {
        console.error(error)
        reject(error)
      })
    })
  }
}

export const api = new APIUser()